export enum ResourcetypeGroups {
    HUMAN = 'human',
    MACHINE = 'machine'
}
